import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';
import { BUSINESS_NAME } from '../config/brand';
import { Scissors } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const token = hash.split('token=')[1]?.split('&')[0];
        const redirectParam = hash.split('redirect=')[1]?.split('&')[0];
        if (!token) {
          navigate('/login', { replace: true });
          return;
        }

        const res = await api.get('/auth/me', { headers: { Authorization: `Bearer ${token}` } });
        const user = res.data;
        login(user, token);

        // Clear hash
        window.history.replaceState(null, '', window.location.pathname);

        const fallback = user.role === 'admin' ? '/admin' : user.role === 'staff' ? '/staff' : '/client/dashboard';
        navigate(redirectParam ? decodeURIComponent(redirectParam) : fallback, { replace: true, state: { user } });
      } catch {
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-[#F9F9F7] flex items-center justify-center">
      <div className="text-center">
        <div className="inline-flex items-center gap-2 mb-6">
          <div className="w-10 h-10 bg-[#2D2D2D] rounded-full flex items-center justify-center">
            <Scissors className="w-5 h-5 text-white" strokeWidth={1.5} />
          </div>
          <span className="text-2xl font-bold text-[#2D2D2D]" style={{ fontFamily: 'Manrope' }}>{BUSINESS_NAME}</span>
        </div>
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-[#2D2D2D] border-t-transparent mx-auto" />
        <p className="mt-4 text-sm text-[#5A5A5A]">Signing you in...</p>
      </div>
    </div>
  );
}
